import dayjs from "dayjs";

export class Dayjs {
  static getAllDaysInMonth(monthStr: string): Date[] {
    const startDate = dayjs(monthStr);
    const endDate = startDate.endOf("month");
    const dates: Date[] = [];

    let currentDate = startDate;
    while (currentDate.isBefore(endDate) || currentDate.isSame(endDate)) {
      dates.push(currentDate.toDate()); // dayjsオブジェクトをDate型に変換
      currentDate = currentDate.add(1, "day");
    }

    return dates;
  }

  static convertStr(date: Date, format: string): string {
    const dateString = dayjs(date).format(format);
    return dateString;
  }
}
